<template>
  <div class="login-container">
    <div class="login-box">
        <h1>Anmelden</h1>

        <form @submit.prevent="login()">
          <div class="input-group">
            <label for="username">Username:</label>
            <input type="text" id="username" v-model="username" maxlength="50" required />
          </div>

          <div class="input-group">
            <label for="password">Passwort:</label>
            <input type="password" id="password" v-model="password" maxlength="50" required />
          </div>

          <button type="submit" class="submit-btn">Einloggen</button>
        </form>
      </div>
  </div>
</template>

<script>
import { loginAdmin } from '../services/dbApi';

export default {
  name: "LogIn",
  data() {
    return {
      username: '',
      password: ''
    };
  },
  methods: {
    sha256Fallback(input) {
      function rightRotate(value, amount) {
        return (value >>> amount) | (value << (32 - amount));
      }

      const words = [];
      const asciiBitLength = input.length * 8;

      for (let index = 0; index < input.length; index++) {
        words[index >> 2] |= (input.charCodeAt(index) & 0xff) << (24 - (index % 4) * 8);
      }

      words[input.length >> 2] |= 0x80 << (24 - (input.length % 4) * 8);
      while ((words.length % 16) !== 14) words.push(0);
      words.push(Math.floor(asciiBitLength / 0x100000000));
      words.push(asciiBitLength & 0xffffffff);

      const hash = [
        0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
        0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
      ];

      const roundConstants = [
        0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
        0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
        0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
        0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
        0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
        0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
        0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
        0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
      ];

      for (let offset = 0; offset < words.length; offset += 16) {
        const w = words.slice(offset, offset + 16);
        for (let t = 16; t < 64; t++) {
          const s0 = (rightRotate(w[t - 15], 7) ^ rightRotate(w[t - 15], 18) ^ (w[t - 15] >>> 3)) >>> 0;
          const s1 = (rightRotate(w[t - 2], 17) ^ rightRotate(w[t - 2], 19) ^ (w[t - 2] >>> 10)) >>> 0;
          w[t] = (w[t - 16] + s0 + w[t - 7] + s1) >>> 0;
        }

        let a = hash[0];
        let b = hash[1];
        let c = hash[2];
        let d = hash[3];
        let e = hash[4];
        let f = hash[5];
        let g = hash[6];
        let h = hash[7];

        for (let t = 0; t < 64; t++) {
          const s1 = (rightRotate(e, 6) ^ rightRotate(e, 11) ^ rightRotate(e, 25)) >>> 0;
          const choose = ((e & f) ^ (~e & g)) >>> 0;
          const temp1 = (h + s1 + choose + roundConstants[t] + w[t]) >>> 0;
          const s0 = (rightRotate(a, 2) ^ rightRotate(a, 13) ^ rightRotate(a, 22)) >>> 0;
          const majority = ((a & b) ^ (a & c) ^ (b & c)) >>> 0;
          const temp2 = (s0 + majority) >>> 0;

          h = g;
          g = f;
          f = e;
          e = (d + temp1) >>> 0;
          d = c;
          c = b;
          b = a;
          a = (temp1 + temp2) >>> 0;
        }

        hash[0] = (hash[0] + a) >>> 0;
        hash[1] = (hash[1] + b) >>> 0;
        hash[2] = (hash[2] + c) >>> 0;
        hash[3] = (hash[3] + d) >>> 0;
        hash[4] = (hash[4] + e) >>> 0;
        hash[5] = (hash[5] + f) >>> 0;
        hash[6] = (hash[6] + g) >>> 0;
        hash[7] = (hash[7] + h) >>> 0;
      }

      return hash.map(value => value.toString(16).padStart(8, '0')).join('');
    },
    // Hash passwords before sending them to the server.
    async sha256(password) {
      if (!window.crypto || !window.crypto.subtle) {
        return this.sha256Fallback(password);
      }
      const msgBuffer = new TextEncoder().encode(password);
      const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    },
    async login() {
      if (!this.username || !this.password) {
        alert('Username und Passwort erforderlich');
        return;
      }

      const hashedPassword = await this.sha256(this.password);

      try {
        const data = await loginAdmin(this.username, hashedPassword);
          sessionStorage.removeItem('email');
          sessionStorage.setItem('isLoggedIn', 'true');
          sessionStorage.setItem('username', data?.username || this.username);
          
          sessionStorage.setItem('isAdmin', data.isAdmin ? 'true' : 'false');

          if (!data.isAdmin) {
            sessionStorage.removeItem('isLoggedIn');
            sessionStorage.removeItem('username');
            sessionStorage.removeItem('isAdmin');
            alert('Nur Admin-Zugang erlaubt. Anmeldung verweigert.');
            return;
          }

          window.dispatchEvent(new Event('auth-changed'));

          this.$router.push('/admin');
      } catch (e) {
        console.error(e);
        alert(e?.message || 'Login fehlgeschlagen');
      }
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  padding-top: 50px;
}

.login-box {
  width: 100%;
  max-width: 400px;
  padding: 30px;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  background: white;
}

h1 {
  text-align: center;
  margin-bottom: 25px;
  color: #2c3e50;
}

.input-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  color: #666;
}

input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

input:focus {
  border-color: #42b983;
  outline: none;
}

.submit-btn {
  width: 100%;
  padding: 12px;
  background-color: #42b983;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 10px;
  transition: background 0.3s;
}

.submit-btn:hover {
  background-color: #369870;
}
</style>